import { render, staticRenderFns } from "./createClientModal.template.vue?vue&type=template&id=515023ed&scoped=true&"
var script = {}
import style0 from "./createClientModal.template.vue?vue&type=style&index=0&id=515023ed&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515023ed",
  null
  
)

export default component.exports